import styled from 'styled-components'

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 20px;
  gap: 10px;
`

export const InputFormText = styled.div`
  width: 100%;
  display: inline-grid;
`

export const ButtonSubmit = styled.div`
  width: 100%;
  margin-top: 10px;
  display: inline-grid;
`
